<script lang="ts" setup>
import {addressService} from '~/api/service/address.service'
import DetailsBox from '~/components/box/DetailsBox.vue'
import PageTitleHeader from '~/components/header/PageTitleHeader.vue'
import AddressCopyLink from '~/components/link/AddressCopyLink.vue'
import {DEPLOYED_CONTRACTS_TABLE_COLUMNS} from '~/constants/contract.constant'
import {DeployedContractModel} from '~/types/model/address.model'
import BcPagination from '~/ui/Pagination/BcPagination.vue'
import BcTable from '~/ui/Table/BcTable.vue'
import {getBreadCrumb} from '~/utils/breadCrumbList'
import {isEmpty} from "~/utils/judge";
import CustomSuspense from "~/components/suspense/CustomSuspense.vue";
import NoDataPreview from "~/components/preview/NoDataPreview.vue";

const {pagination, rowPerPageList} = usePagination({
  page: 1,
  rowPerPage: 25
})

const {data, isLoading} = addressService.useGetDeployedContractList(pagination)

const rows = computed(() => {
  return data.value?.contractList ?? []
})

useSeoMeta(getMeta('Deployed Contracts', 'View the deployed contracts'))

useHead(getBreadCrumb())
</script>

<template>
  <PageTitleHeader title="Deployed Contracts"/>
  <DetailsBox class="my-4">
    Showing all <span class="font-bold text-primary">{{ data?.formattedTotalCount }}</span> results
    <template #pagination>
      <BcPagination
        v-if="data?.viewCount"
        :model-value="pagination"
        :row-per-page-list="rowPerPageList"
        :total-count="data.viewCount"
        hide-rows-per-page
      />
    </template>
  </DetailsBox>
  <Card>
    <CustomSuspense
      :is-loading="isLoading"
      :is-empty="isEmpty(rows)"
    >
      <template #loading>
        <LoadingTable
          :row-cnt="pagination.rowPerPage"
          :cols="DEPLOYED_CONTRACTS_TABLE_COLUMNS"
        />
      </template>
      <template #empty>
        <NoDataPreview/>
      </template>
      <template #default>
        <BcTable
          :rows="rows"
          :cols="DEPLOYED_CONTRACTS_TABLE_COLUMNS"
        >
          <template #address="{row}: {row: DeployedContractModel}">
            <AddressCopyLink
              :address="row.address"
              :tab="accountDetailPageType.contractCode"
              type="CA"
              class="link"
            />
          </template>
        </BcTable>
      </template>
    </CustomSuspense>
    <BcPagination
      v-if="data?.viewCount"
      :model-value="pagination"
      :row-per-page-list="rowPerPageList"
      :total-count="data.viewCount"
    />
  </Card>
</template>

<style scoped lang="scss">
.link {
  max-width: 200px;

  @include over_xl {
    max-width: 270px;
  }
}
</style>